import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { queries } from 'RestAPIs/rapini';

import type { GridColDef, GridRowId } from '@mui/x-data-grid-pro';
import { GridToolbar } from '@mui/x-data-grid-pro';

import { DataGrid } from 'components/shared';

import MappingFunctionsDialog from './MappingFunctionsDialog';

type Props = {
  regionalPoolTenantName: string | null;
};

export default function MappingFunctionsGrid({
  regionalPoolTenantName
}: Props) {
  const { t } = useTranslation('common');

  const [open, setOpen] = useState(false);
  const [regionalPoolFunctionId, setRegionalPoolFunctionId] = useState<
    number | undefined
  >();

  const [pageSize, setPageSize] = useState(10);

  const [tenantFunctionId, setTenantFunctionId] = useState<number | null>(null);
  const { data, isLoading } = queries.useGetRegionalPoolFunctionMappings(
    regionalPoolTenantName as string,
    {
      enabled: !!regionalPoolTenantName
    }
  );

  const columns: GridColDef[] = [
    {
      field: 'tenantFunctionName',
      headerName: t('functionRequest'),
      flex: 1
    },
    {
      field: 'regionalPoolFunctionName',
      headerName: t('functionRegionalPool'),
      flex: 1
    }
  ];

  const rows =
    data?.map((r) => ({
      id: r.tenantFunctionId,
      tenantFunctionName: r.tenantFunctionName,
      regionalPoolFunctionId: r.regionalPoolFunctionId,
      regionalPoolFunctionName: r.regionalPoolFunctionName ?? ''
    })) ?? [];

  function handleEditClick(id: GridRowId, row) {
    setRegionalPoolFunctionId(row.regionalPoolFunctionId);
    setTenantFunctionId(id as number);
    setOpen(true);
  }

  return (
    <>
      <DataGrid
        loading={isLoading}
        title={t('mappingFunctions')}
        columns={columns}
        rows={rows}
        pagination
        pageSize={pageSize}
        rowsPerPageOptions={[10, 20, 50]}
        onPageSizeChange={(newSize) => setPageSize(newSize)}
        onEditClick={handleEditClick}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
            printOptions: { disableToolbarButton: true },
            csvOptions: { disableToolbarButton: true }
          }
        }}
        addRowDialog={
          <MappingFunctionsDialog
            title="Functie mapping bewerken"
            setOpen={setOpen}
            open={open}
            regionalPoolFunctionId={regionalPoolFunctionId}
            setRegionalPoolFunctionId={setRegionalPoolFunctionId}
            regionalPoolTenantName={regionalPoolTenantName as string}
            tenantFunctionId={tenantFunctionId as number}
          />
        }
      />
    </>
  );
}
